import { jsx as _jsx } from "react/jsx-runtime";
import { logger } from '@lichtblick/logger';
import { RichText } from './RichText';
// CMS delivers the keys separated by a hyphen, but the AllInOneCalculator and the Forms expect camel case.
const maintenanceProductMap = {
    'form-b2b-electricity': 'formB2bElectricity',
    'form-b2b-gas': 'formB2bGas',
    'home-charging': 'homeCharging',
    'on-road-charging': 'onRoadCharging'
};
// CMS delivers the key "home-charging", but the AllInOneCalculator expects "homeCharging".
const mapProductName = (product)=>product in maintenanceProductMap ? maintenanceProductMap[product] : product;
export const createMaintenanceProductsConfig = async (products)=>{
    const productEntries = await Promise.all((products ?? []).map(async (collectionItem)=>{
        const ReactDOMServer = (await import('react-dom/server')).default;
        const { maintenanceText, product } = collectionItem || {};
        const { button, text } = maintenanceText?.[0] || {};
        if (!product) {
            logger.warn(`Unable to create maintenance config for product ${product}.`);
            return null;
        }
        const markup = /*#__PURE__*/ _jsx(RichText, {
            richText: text
        }, collectionItem._uid);
        return {
            [mapProductName(product)]: {
                text: {
                    buttonText: button?.[0]?.text,
                    buttonLink: button?.[0]?.linkUrl,
                    text: ReactDOMServer.renderToStaticMarkup(markup)
                }
            }
        };
    }));
    return productEntries.reduce((acc, entry)=>{
        if (entry) {
            Object.assign(acc, entry);
        }
        return acc;
    }, {});
};

//# sourceMappingURL=createMaintenanceProductsConfig.js.map